angular.module('rjmNg.api').factory 'ImportApi', [
  "$resource"
  "phpServiceUrl"
  (
    $resource,
    phpServiceUrl
  ) ->

    (clientId) ->

      importAPIBaseUrl = phpServiceUrl("/client/#{clientId}/importapi")

      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        generateNewToken: angular.extend {}, defaultParams,
          method: 'POST'
          url: importAPIBaseUrl + "/token"
        create: angular.extend {}, defaultParams,
          method: 'POST'
        save: angular.extend {}, defaultParams,
          method: 'POST'
          url: importAPIBaseUrl + "/:id/edit"

      importApiResource = $resource(importAPIBaseUrl, {}, actions)

      create: (connection) ->
        importApiResource.create({}, connection).$promise
      save: (connection) ->
        if connection.id?
          importApiResource.save({id: connection.id}, connection).$promise
        else
          importApiResource.create({}, connection).$promise
      generateNewToken: () ->
        importApiResource.generateNewToken().$promise
]
